import Workshop from 'marketing-website/media/images/pages/resources/workshop-resources@2x.jpg';
import Santander from 'marketing-website/media/images/pages/resources/webinar-santander@2x.png';
import UserTesting from 'marketing-website/media/images/pages/resources/user-testing-webinar@2x.png';

import Murat from 'marketing-website/media/images/avatars/murat.jpg';
import Zorast from 'marketing-website/media/images/avatars/zorast@2x.png';
import Bobby from 'marketing-website/media/images/avatars/BobbyChadha@2x.jpg';

const webinarData = [
  {
    avatarOneImage: Murat,
    labelMessage: 'COMING SOON',
    excerpt: 'Getting started with User Testing and the all-new Marvel 3',
    image: {
      alt: 'UserTesting',
      src: UserTesting,
    },
    url: '/resources/webinar-get-started-with-marvel-3',
  },
  {
    avatarOneImage: Bobby,
    labelMessage: 'ON DEMAND',
    excerpt: 'Principles of User Testing at Santander',
    image: {
      alt: 'Santander',
      src: Santander,
    },
    url: '/resources/webinar-marvel-santander-03-2019',
  },
  {
    avatarOneImage: Murat,
    avatarTwoImage: Zorast,
    labelMessage: 'ON DEMAND',
    excerpt: 'How to run your first Design Thinking Workshop',
    image: {
      alt: 'Design Thinking Workshop',
      src: Workshop,
    },
    url: '/resources/webinar-design-thinking-02-2019',
  },
];

export default webinarData;



// WEBPACK FOOTER //
// ./src/configs/pages/resources/webinarData.js